import { Routes } from 'constants/index'
import UploadIcon from 'ez-styles/assets/icons/circle/circle-plus.svg'
import MenuIcon from 'ez-styles/assets/icons/menu.svg'
import VecteezyIcon from 'ez-styles/assets/img/logos/rebrand/orange-logomark.svg'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Notifications from '../Notifications'
import Menu from './menu'

import { ContributorNotification } from 'types/api'
import { Session } from '../../types'

import { gevent } from 'helpers/gtag'

import * as S from './styled'

type Props = {
  notifications: ContributorNotification[] | null
  notificationsLoading: boolean
  session?: Session
}

const MobileNavigation = ({
  notifications,
  notificationsLoading,
  session,
}: Props) => {
  const [showSidebar, setShowSidebar] = useState(false)
  const navigate = useNavigate()
  const isAdmin = Boolean(session?.isAdmin)
  const needsAccountSetup = Boolean(!isAdmin && session?.needsAccountSetup)
  const needsOnboarding = Boolean(!isAdmin && session?.needsOnboarding)

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }

  const handleUploadPress = () => {
    gevent('upload', 'Any', { source: 'Mobile Nav Button' })
    navigate(Routes.PortfolioUpload)
  }

  const handleNavigation = () => {
    if (needsOnboarding) {
      navigate(Routes.PortfolioUpload)
    } else {
      navigate('/')
    }
  }

  if (!session) {
    return null
  }

  return (
    <>
      <S.MobileMenu data-testid="cm-mobile-nav">
        <S.LogoWrapper onClick={handleNavigation} data-testid="nav-logo">
          <VecteezyIcon />
        </S.LogoWrapper>
        <S.ActionsWrapper>
          <>
            <S.NavIconWrapper
              onClick={needsAccountSetup ? () => {} : handleUploadPress}
              data-testid="upload-nav-icon"
              $locked={needsAccountSetup}
            >
              <UploadIcon />
            </S.NavIconWrapper>

            {!needsAccountSetup && !needsOnboarding ? (
              <Notifications
                notifications={notifications}
                loading={notificationsLoading}
                isMobile
                data-testid="notifications-nav-icon"
              />
            ) : null}
          </>
          <S.NavIconWrapper onClick={toggleSidebar} data-testid="menu-nav-icon">
            <MenuIcon />
          </S.NavIconWrapper>
        </S.ActionsWrapper>
      </S.MobileMenu>
      <Menu
        isOpen={showSidebar}
        onClose={() => setShowSidebar(false)}
        session={session}
      />
    </>
  )
}

export default MobileNavigation
